import TagsInputField from './TagsInputField';

export default TagsInputField;
